import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import type { ComponentProps } from "react";
import { useState } from "react";

type Props = Omit<ComponentProps<typeof QueryClientProvider>, "client">;

function TanstackQueryProvider({ children }: Props) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
}

export { TanstackQueryProvider };
